module.exports = {
  ...require("./address"),
  ...require("./invoice"),
  ...require("./product"),
  ...require("./parcel"),
  ...require("./consignment"),
  ...require("./shipment"),
};
